// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3dwNB","productName":"Table_productName__2ivPm"};